var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fz-Nesspresso col__black app",class:{ init: _vm.inited },staticStyle:{"opacity":"0"}},[_c('Landing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }